const minutesAgo = (minutes: number) => (minutes < 1 ? 'less than a minute ago' : `${minutes} min ago`);

export default {
  // What the user reads before the claim lock has answered, as the server names an SoR without a display name.
  defaultSorName: 'System of Record',
  // Titled by what the System of Record did; the server's message, shown verbatim beneath, names the SoR.
  errorTitles: {
    sor_rejected: 'Rejected by the System of Record',
    sor_request_refused: 'Not processed by the System of Record',
    sor_unreachable: 'System of Record unavailable',
    sor_unconfirmed: 'Not confirmed by the System of Record',
    sor_operation_in_progress: 'Claim is read-only',
  },
  freezeReason: (sorName: string, label: string) =>
    `Waiting for ${sorName} to confirm ${label}; the claim is read-only until then`,
  bannerPending: (sorName: string, label: string, minutes: number) =>
    `${sorName} hasn't confirmed the last change on this claim (${label}, ${minutesAgo(minutes)}). ` +
    'The claim is read-only until it does.',
  bannerNeedsAttention: (sorName: string, label: string, minutes: number) =>
    `${sorName} didn't confirm the last change on this claim (${label}, ${minutesAgo(minutes)}), and CMS stopped ` +
    'checking. The claim stays read-only until an operator resolves it.',
  viewInIssues: 'View in Issues',
  saving: (sorName: string) => `Waiting for ${sorName} to confirm your change…`,
  savingSeconds: (seconds: number) => `${seconds}s`,
  requestTimedOut: (sorName: string) =>
    `${sorName} did not confirm this change in time. Do not redo it: we are checking with ${sorName}, and the claim stays read-only until it is settled.`,
};
